import { createSlice } from "@reduxjs/toolkit"
import axios from "axios"

export const contactUsSlide = createSlice({
    name: "contactUs",
    initialState: {
        sendContactUsMessageSuccess: false,
        sendContactUsMessageFail: false,
        sendContactUsMessageErrorDetail: null,
    },
    reducers: {
        doSendContactUsMessageSuccess: (state, action) => {
            state.sendContactUsMessageSuccess = true
            state.sendContactUsMessageFail = false
            state.sendContactUsMessageErrorDetail = null
        },
        doSendContactUsMessageFail: (state, action) => {
            state.sendContactUsMessageSuccess = false
            state.sendContactUsMessageFail = true
            state.sendContactUsMessageErrorDetail = action.payload.data
        },
        resetContactUsMessageState: (state, action) => {
            state.sendContactUsMessageSuccess = false
            state.sendContactUsMessageFail = false
            state.sendContactUsMessageErrorDetail = null
        },
    },
})

export const doSendContactUsMessage = (param) => async (dispatch) => {
    try {
        const url = `/api/contact-us`

        const response = await axios.post(url, param)
        dispatch(doSendContactUsMessageSuccess(response.data))
    } catch (error) {
        dispatch(doSendContactUsMessageFail(error.response))
    }
}

export const doResetContactUsMessageState = () => async (dispatch) => {
    dispatch(resetContactUsMessageState());
}

export const {
    doSendContactUsMessageSuccess,
    doSendContactUsMessageFail,
    resetContactUsMessageState,
} = contactUsSlide.actions

export const getSendContactUsMessageSuccess = (state) => state.contactUs?.sendContactUsMessageSuccess
export const getSendContactUsMessageFail = (state) => state.contactUs?.sendContactUsMessageFail
export const getSendContactUsMessageErrorDetail = (state) => state.contactUs?.sendContactUsMessageErrorDetail

export default contactUsSlide.reducer